import { Modal } from 'antd';
import { CustomImage } from './index';
import modalClose from '@src/assets/icons/icon-modal-close.svg';
import modalError from '@src/assets/icons/icon-modal-error.svg';
import '@src/styles/components/dialog.scss';
import Text from './Text';
import PropTypes from 'prop-types';

let customModal = Modal;

const Header = ({ title, closeModal, icon }) => {
  return (
    <div className="dialog-header">
      <div className={'title-content'}>
        <CustomImage className={`image-error`} src={icon} />
        <div className="title">{title}</div>
      </div>
      <CustomImage
        data-testid="close-modal"
        className="close-image"
        src={modalClose}
        onClick={closeModal}
      />
    </div>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  closeModal: PropTypes.any,
  icon: PropTypes.any,
};

const BoldMultipleContent = ({
  boldMessage,
  multipleTypeMessage1,
  multipleTypeMessage2,
  multipleTypeMessage3,
}) => {
  return (
    <div className={'dialog-content-multiple'}>
      <b className="bold-message-p">{boldMessage}</b>
      <p>
        {multipleTypeMessage1}
        <b className="bold-message-p">{multipleTypeMessage2}</b>
        {multipleTypeMessage3}
      </p>
    </div>
  );
};

BoldMultipleContent.propTypes = {
  boldMessage: PropTypes.string,
  multipleTypeMessage1: PropTypes.string,
  multipleTypeMessage2: PropTypes.string,
  multipleTypeMessage3: PropTypes.string,
};

const ErrorDialog = ({ title }) => {
  const modal = customModal.info({
    width: 503,
    title: (
      <Header
        title={title}
        closeModal={() => {
          modal?.destroy();
        }}
        icon={modalError}
      />
    ),
    content: (
      <BoldMultipleContent
        boldMessage={'Araç ekleme işlemi sırasında bir sorun yaşandı.'}
        multipleTypeMessage1={'Detaylı inceleme için '}
        multipleTypeMessage2={'musteri@ticket.com '}
        multipleTypeMessage3={'adresine e-posta gönderiniz.'}
      />
    ),
    icon: false,
    className: 'custom-dialog',
    okText: <Text t="okBtn" />,
    autoFocusButton: 'ok',
    keyboard: false,
    onOk: () => {
      modal?.destroy();
    },
  });

  return modal;
};
ErrorDialog.propTypes = {
  title: PropTypes.string,
};

export default ErrorDialog;
